export default __webpack_public_path__ + "static/media/grupos apple.8144af47.png";